import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
const AppUserList = ({ el }) => {
  const { t } = useTranslation();
  console.log(el, ">>thisis");
  const navigate = useNavigate();

  return (
    <div
      className="px-[24px] border-b-[1px] py-[18px] cursor-pointer"
      onClick={() => {
        navigate("/myinfo/appusecont", {
          state: el.id
        });
      }}
    >
      {el.status === 1 ? (
        <span className="inline-block px-[6px] py-[2px] caption_2 text-white rounded-sm bg-[#1B5EDC] caption_2">
          {t('AppUseList_answer_complete', '답변완료')}
        </span>
      ) : (
        <span className="inline-block px-[6px] py-[2px] caption_2 border rounded-sm border-[#999CA3] text-[#999CA3] caption_2">
          {t('AppUseList_answer_waiting', '답변대기')}
        </span>
      )}
      <div className="pt-[6px]">
        <span className="body_1_600">
          [
          {el.category === 0
            ? t('AppUseList_service_inquiry', '서비스 문의')
            : el.category === 1
            ? t('AppUseList_issue_report', '장애 및 불편신고')
            : el.category === 2
            ? t('AppUseList_suggestion', '제안사항')
            : el.category === 3
            ? t('AppUseList_other', '기타')
            : ""}
          ]
        </span>
        <span className="text-[#343B48] pl-2">{el.title}</span>
      </div>
      <div className="text-[#999CA3] caption_1_400 pt-[4px]">
        {dayjs(el.createdAt).format("YYYY.MM.DD")}{" "}
        {dayjs(el.createdAt).format("A") === "AM" ? t('AppUseList_am', '오전') : t('AppUseList_pm', '오후')}{" "}
        {dayjs(el.createdAt).format("H") > 12
          ? dayjs(el.createdAt).format("H") - 12
          : dayjs(el.createdAt).format("H")}
        {t('AppUseList_hour', '시')}
      </div>
    </div>
  );
};

export default AppUserList;
